__turbopack_context__.v({
  "actions": "AddressConfirmModal-module-scss-module__RmBSXG__actions",
  "card": "AddressConfirmModal-module-scss-module__RmBSXG__card",
  "cardAddressLine": "AddressConfirmModal-module-scss-module__RmBSXG__cardAddressLine",
  "cardContent": "AddressConfirmModal-module-scss-module__RmBSXG__cardContent",
  "cardTitle": "AddressConfirmModal-module-scss-module__RmBSXG__cardTitle",
  "modalBody": "AddressConfirmModal-module-scss-module__RmBSXG__modalBody",
  "modalTitle": "AddressConfirmModal-module-scss-module__RmBSXG__modalTitle",
  "radioCards": "AddressConfirmModal-module-scss-module__RmBSXG__radioCards",
  "radioInput": "AddressConfirmModal-module-scss-module__RmBSXG__radioInput",
  "selected": "AddressConfirmModal-module-scss-module__RmBSXG__selected",
});
